import { pxToRem, labelClassName, pxArrayToRem } from '@archipro-design/aria';
import type { StyleRule } from '@archipro-design/aria';

const TOTAL_WIDTH = 128;
const RADIUS_WIDTH = 50;
const BUTTON_HEIGHT = 32;
const MAIN_PADDING = 16;

export const SwitchButton: StyleRule = ({
    theme,
    activeButtonFirst = true,
}) => {
    const ACTIVE_WIDTH = activeButtonFirst ? 71 : 64;
    const INACTIVE_WIDTH = TOTAL_WIDTH - ACTIVE_WIDTH - 2 + RADIUS_WIDTH / 2;

    return {
        [theme.screen.tablet]: {
            width: pxToRem(TOTAL_WIDTH),
            height: pxToRem(BUTTON_HEIGHT),
            paddingTop: pxToRem(6),
            marginRight: activeButtonFirst ? pxToRem(7) : pxToRem(16),

            [`& .${labelClassName}`]: {
                fontSize: pxToRem(14),
                lineHeight: 1,
                letterSpacing: theme.siteVariables.letterSpacingNormal,
            },

            '& .active': {
                width: pxToRem(ACTIVE_WIDTH),
                height: pxToRem(BUTTON_HEIGHT),
                padding: 0,
                borderRadius: pxToRem(RADIUS_WIDTH),
                background: theme.siteVariables.colors.white['FFF'],
                border: `1px solid ${theme.siteVariables.colors.primitive.black}`,
                marginRight: activeButtonFirst ? pxToRem(-RADIUS_WIDTH / 2) : 0,
                marginLeft: activeButtonFirst ? 0 : pxToRem(-RADIUS_WIDTH / 2),
                zIndex: theme.siteVariables.zIndexes.foreground,
                fontWeight: theme.siteVariables.fontWeightRegular,
                color: theme.siteVariables.colors.primitive.black,
                cursor: 'default',
                ':hover': {
                    color: theme.siteVariables.colors.primitive.black,
                    background: theme.siteVariables.colors.white['FFF'],
                    border: `1px solid ${theme.siteVariables.colors.primitive.black}`,
                },
            },
            '& .inactive': {
                width: pxToRem(INACTIVE_WIDTH),
                height: pxToRem(BUTTON_HEIGHT),
                background: theme.siteVariables.colors.white[200],
                border: 0,
                borderRadius: activeButtonFirst
                    ? pxArrayToRem([0, RADIUS_WIDTH, RADIUS_WIDTH, 0])
                    : pxArrayToRem([RADIUS_WIDTH, 0, 0, RADIUS_WIDTH]),
                paddingLeft: pxToRem(
                    activeButtonFirst ? 12 + RADIUS_WIDTH / 2 : MAIN_PADDING
                ),
                paddingRight: pxToRem(
                    activeButtonFirst ? MAIN_PADDING : 12 + RADIUS_WIDTH / 2
                ),
                ':hover': {
                    border: 0,
                },
            },
        },
    };
};
